import { MessageCircle } from "lucide-react";
import { featured, waLink } from "@/config/business";
import { Reveal, Overline } from "@/components/Reveal";

export default function Featured() {
  return (
    <section className="py-20 md:py-32 bg-white" data-testid="featured-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <Reveal>
          <Overline>Featured</Overline>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl tracking-tight text-ink max-w-xl">
            Loved Most by Our Customers
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((f, i) => (
            <Reveal key={f.title} delay={(i % 3) * 0.08}>
              <article
                data-testid={`featured-tile-${i}`}
                className="group relative overflow-hidden h-[340px] bg-deep"
              >
                <img
                  src={f.img}
                  alt={f.alt}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:scale-105 group-hover:opacity-70 transition-[transform,opacity] duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-deep/90 via-deep/20 to-transparent" aria-hidden="true" />
                <div className="absolute inset-x-0 bottom-0 p-6 flex items-end justify-between gap-4">
                  <h3 className="font-display text-2xl text-cream">{f.title}</h3>
                  <a
                    data-testid={`featured-whatsapp-${i}`}
                    href={waLink(`Hi Lavniya! I'd like to enquire about ${f.title}.`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Enquire about ${f.title} on WhatsApp`}
                    className="shrink-0 inline-flex items-center gap-2 bg-wa text-white px-4 py-2.5 text-xs font-semibold uppercase tracking-widest opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-[opacity,transform] duration-300 min-h-[44px]"
                  >
                    <MessageCircle size={14} /> Enquire
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
